<div class="context-menu" (click)="$event.stopPropagation()">
  <ul *ngFor="let category of categoryArray">
    <li class="category-item">
      {{ category.name ?? category.id }}
    </li>
    <li
      *ngFor="let option of category.options"
      class="label-item"
      (click)="$event.stopPropagation(); toggle(option)"
      (mouseenter)="optionHovered.emit(option)"
      (mouseleave)="optionUnhovered.emit(option)"
    >
      <ng-container *ngIf="options[option] as label">
        <span *ngIf="isChecked(option)" class="ri-check-line" style="font-size: 21px"></span>

        <span *ngIf="isDoubleChecked(option)" class="ri-check-double-line" style="font-size: 21px"></span>
        {{ label.name ?? label.id }}
      </ng-container>
    </li>
  </ul>
</div>
